<template>
  <el-dialog v-bind='$attrs' v-on='$listeners' @open='onOpen'
             :close-on-click-modal="false" id="my-element" @close='onClose'>
    <template slot='title'>
      <div style="height: 0">
        <el-link class='pptTitle' @click='getDataList'>{{ KolNickname }} {{ dialogTitle }}</el-link>
        <svg-icon style='cursor: pointer' @click='changeFull'
                  :icon-class="fullscreen?'offScreen':'fullscreen'"></svg-icon>
        <el-button icon="el-icon-edit" class="ml-10" type="success"
                   @click="editData('opt_remark',formData.opt_remark)">
          运营备注
        </el-button>
      </div>
    </template>
    <div class="alertPage" v-show="loading">
      <img :src="loadingImg">
      {{ loadingText }}
    </div>

    <div :class="{'animate__animated': true, 'animate__fadeInLeft': showData,'animate__fadeOutRight': !showData}"
         class='preview-box overflow-hidden'>
      <transition name='el-fade-in-linear' v-if='formData?.state>0'>
        <el-image v-show='showStateImg' class='stateImg' :src='stateImg[`state_${formData.state}`]'></el-image>
      </transition>

      <el-row :gutter='24' class='base-info'>
        <el-col :span='18' class="box">
          <div v-if="formData.is_show_inquiry === 1" class="chat-quan-an">
            <img :src="chat_quan_an"/>
            <span class="space"> {{ formData.is_inquiry_product }}</span>
            <span class="online">{{ formData.qty_policy }}</span>

          </div>
          <div v-if="isHightKickback" class="hightKickback">
            <img :src="high_kickback"/>
            <span class="space"> {{ formData.ad_space_fee ? formData.ad_space_fee : '暂无' }}
            </span>
            <span class="online">{{ formData.online_cmn }} %
            </span>

          </div>
          <div style="max-height: 434px;">
            <div class='title' style='display: flex;justify-content: space-between;'>
              <span>{{ formData.company_name }}</span>
              <b v-if='formData&&formData.updated_at'
                 style='color: darkred;font-size: 14px;'>（商品最后更新时间：{{ formData.updated_at }}）</b>
            </div>
            <el-descriptions :labelClassName="'labelClass'" :contentClassName="'contentClass'" class="margin-top"
                             :column="1" :size="'mini'">
              <el-descriptions-item>
                <template slot="label">
                  商品名称及规格
                </template>
                <span>{{ formData.title }}({{ formData.spec_name }})</span>

              </el-descriptions-item>
              <template v-for="(item,index) in configData">
                <el-descriptions-item :key="index" v-if="item.isShow">
                  <template slot="label">
                    {{ item.title }}
                  </template>
                  <div
                    class="inline-block" style="max-width: 1100px"
                    :style="[{color:item.color||''},{fontSize:item.title==='坑位费'||item.title==='线上/线下佣金'?'20px':'16px'||''}]"
                    v-for="i in item.value" :key="i"
                  >
                    <template v-if="!(['special_remark','other_activity'].includes(i))">{{ formData[i] || '/' }} {{
                      formData[i] ? item.unit : ''
                    }}
                    </template>
                    <template v-if="(['online_cmn'].includes(i))">
                      &nbsp;
                    </template>
                    <template v-else-if="i==='special_remark'&&formData.unify===2">{{
                      formData[i] || '/'
                    }} {{ formData[i] ? item.unit : '' }}
                    </template>
                    <template v-else-if="i==='other_activity'&&formData.exclusive===1">{{
                      formData[i] || 'znw'
                    }} {{ formData[i] ? item.unit : '' }}
                    </template>
                  </div>
                  <i v-if='isPreview' class="el-icon-close" @click="handleClose(item,false)"></i>
                </el-descriptions-item>
              </template>
            </el-descriptions>

          </div>
          <el-row class='light-spot-box'>
            <div class='light-spot-title' @dblclick='editData("light_spot",formData.light_spot)'>亮点卖点（简洁）
            </div>
            <div  @dblclick='editData("light_spot",formData.light_spot)'
                  style="overflow-y: scroll" v-html='formData.light_spot'>
            </div>
          </el-row>
        </el-col>
        <el-col :span='6'>
          <div class='cover-box' @dblclick="editImgBtn">
            <div class='cover-title'>
              商品图片
              <i v-if="formData.ingredient_propose_parse&&formData.ingredient_propose_parse.length!=0"
                 class="el-icon-document ingredient-icon" @click="openIngredientDialog"></i>
            </div>
            <div class='cover-view'>
              <el-image fit='cover' class='cover-image'
                        :src='formData.cover_url'>
                <div slot="error" class="image-slot">
                  <div class="image-slot">
                    o(╥﹏╥)o
                    <br/>
                    <span>暂无图片</span>
                  </div>
                </div>
              </el-image>
            </div>
          </div>
          <div class="introBox">
            <div class='intro' v-html="formData.intro "
                 @dblclick.prevent='editData("intro",formData.intro)'></div>
          </div>

        </el-col>
      </el-row>
    </div>
    <div class='opt-box'>
      <el-row>
        <div class="configure" v-if='isPreview'>
          <el-tag
            class="cursor-pointer"
            @click="handleClose(tag,true)"
            type="info"
            size="medium"
            effect="plain"
            v-for="tag in closeList"
            :key="tag.title"
          >
            {{ tag.title }}
          </el-tag>
        </div>
      </el-row>
      <el-row :gutter='10'>
        <el-col :span='4'>
          <el-button :disabled="showIndex===0" size='medium' icon='el-icon-arrow-left' @click='preBtn'>上一页
          </el-button>
        </el-col>

        <el-col :span='16' style='text-align: center'>
          <el-button-group v-if='!isPreview && userPermissions.indexOf("lb_kol_selection_state")>-1'>
            <el-button :type="formData?.state===item.value?'primary':''" size='medium' v-for='item in stateOptions'
                       :key='item.value' :disabled="loading"
                       @click='onchange(item.value)'>{{ item.label }}
            </el-button>
            <el-button @click="localNextOne">
              <el-checkbox @change="localNextOne" v-model="isNextOne">自动下一页</el-checkbox>
            </el-button>
          </el-button-group>
        </el-col>
        <el-col :span='4' style='text-align: right;float: right'>
          <el-button size='medium'
                     :disabled="showIndex === dataList.length - 1" @click='nextBtn'>下一页<i
                       class='el-icon-arrow-right'></i>
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      width="70%"
      @close='closeEdit'
      :destroy-on-close="true"
      :visible.sync="introVisible"
      append-to-body>
      <template slot='title'>
        <span class="pptTitle" style="font-size: 18px">
          修改{{ addTitle }}</span>
        <el-button class="float-right" style="margin-right: 50px" @click='saveEdit' type='primary'>保存
        </el-button>
      </template>
      <ApeEditor
        v-if="this.editType==='light_spot'&&introVisible"
        :editorHeight="500"
        :inline='true'
        :init-html='editContent'
        :toolbar="'undo redo paste | bold italic underline strikethrough | fontselect fontsizeselect |  forecolor backcolor | ' +
          'ltr rtl | alignleft aligncenter alignright alignjustify | bullist numlist' +
          ' | outdent indent blockquote | removeformat anchor hr |' +
          ' code preview fullscreen'"
        @handleTinymceInput='handleTinymceInput'></ApeEditor>
      <el-input v-else type="textarea" v-model="editContent" :rows="30"></el-input>
    </el-dialog>
    <el-dialog :destroy-on-close="true" :visible.sync="editImgDialog" append-to-body title="商品图片替换" width="20%">
      <ApeUploader :limit='1' :upload-file-list='uploadFileList'
                   uploadTip='请上传图片，最多上传1份。大小限制2M文件'
                   @handleUploadRemove='handleUploadRemove'
                   @handleUploadSuccess='handleUploadSuccess'></ApeUploader>
      <br/>
      <div style="text-align: center;">
        <el-button type="primary" @click="saveImg">提交</el-button>
        <el-button @click="cancelBtn">取消</el-button>
      </div>
    </el-dialog>

    <!-- 成分表弹框 -->
    <el-dialog
      :visible.sync="ingredientVisible"
      title="成分表"
      width="80%"
      append-to-body
      :destroy-on-close="true">
      <div class="ingredient-content">
        <!-- AI分析结果 -->
        <div v-if="formData.ingredient_propose_ai" class="ai-analysis">
          该数据由 {{ formData.ingredient_propose_ai }} 生成
        </div>

        <el-table
          v-if="formData.ingredient_propose_parse && formData.ingredient_propose_parse.table"
          :data="formData.ingredient_propose_parse.table.td"
          border
          stripe
          class="w-full"
          height="400">
          <el-table-column
            v-for="(header, index) in getTableHeaders()"
            :key="index"
            :prop="header"
            :label="header"
            :min-width="getColumnWidth(header)">
            <template slot="header">
              <span class="font-bold">{{ header }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="no-data">
          <p>暂无成分表数据</p>
        </div>

        <!-- 注意信息 -->
        <div v-if="formData.ingredient_propose_parse && formData.ingredient_propose_parse.memo">
          <h4 style="font-weight: bold; margin: 20px 0 10px 0; color: black;"> 注意: <span
            class="memo-content">{{ formData.ingredient_propose_parse.memo }}</span></h4>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeIngredientDialog" class="w-full">关闭</el-button>
      </div>
    </el-dialog>

  </el-dialog>

</template>

<script>
import ApeEditor from '@/components/ApeEditor'
import state_1 from '@/assets/imgs/1.png'
import state_2 from '@/assets/imgs/2.png'
import state_3 from '@/assets/imgs/3.png'
import state_4 from '@/assets/imgs/4.png'
import state_5 from '@/assets/imgs/5.png'
import high_kickback from '@/assets/imgs/high-kickback.png'
import loadingImg from '@/assets/icons/lbLoading.png'
import chat_quan_an from '@/assets/imgs/chat-quan-an.png'
import 'animate.css'
import {mapGetters} from 'vuex'
import ApeUploader from '@/components/ApeUploader'

export default {
  name: 'SelectionPreview',
  props: {
    lbId: {
      type: [Number, String]
    },
    currentIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    searchCondition: {
      type: Object,
      default() {
        return {}
      }
    },
    KolNickname: {
      type: String
    },
    typeData: {
      type: String
    },
    listData: {
      type: Array,
      default() {
        return []
      }
    },
    isType: {
      type: [Number, String]

    }

  },
  components: {
    ApeEditor, ApeUploader
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    dialogTitle() {
      return `${this.isPreview ? '预览' : '选品'}(${this.showIndex + 1}/${this.dataList.length})`
    },
    isPreview() {
      //如果是预览就不要显示按钮和显示全部的列表
      return this.typeData === 'preview'
    },
    isHightKickback() {
      if (this.formData) {
        return this.formData.ad_space_fee > 0 || this.formData.online_cmn > 35 || this.formData.offline_cmn > 35
      } else return false
    },
    addTitle() {
      return this.editType === 'intro' ? '品牌背书' : this.editType === 'light_spot' ? '产品亮点' : '运营备注'
    },
    closeList() {
      return this.configData.map(i => {
        return i.isShow === false ? i : null
      }).filter(Boolean)
    }
  },
  data() {
    return {
      formData: {},
      stateOptions: [
        { label: '上播', value: 1, color_value: '#FFFFFF' },
        { label: '不上播', value: 2, color_value: '#67C23A' },
        { label: '红人试用', value: 3, color_value: '#409EFF' },
        { label: '团队试用', value: 4, color_value: '#E6A23C' },
        { label: '待定/备选', value: 5, color_value: '#E6A23C' }
      ],
      dataList: [],
      fullscreen: true,
      stateImg: {
        state_1: state_1,
        state_2: state_2,
        state_3: state_3,
        state_4: state_4,
        state_5: state_5
      },
      showStateImg: true,
      showIndex: 0,
      introVisible: false,
      editContent: '',
      editValue: '',
      editType: '',
      isNextOne: false,
      loading: false,
      loadingImg: loadingImg,
      showData: true,
      loadingText: '',
      uploadFileList: [],
      editImgDialog: false,
      editImg: '',
      configData: [
        { title: '店铺评分', value: ['company_score'], isShow: true, unit: '分' },
        { title: '坑位费', value: ['ad_space_fee'], isShow: true, size: '18px' },
        {
          title: '线上/线下佣金',
          value: ['online_cmn', 'offline_cmn'],
          isShow: true,
          color: '#F56C6C',
          unit: '%',
          size: '18px'
        },
        { title: '日常价', value: ['price'], isShow: true },
        { title: '直播价', value: ['lb_price'], isShow: true, color: '#F56C6C' },
        { title: '赠品', value: ['gift'], isShow: true },
        { title: '是否全网统一机制', value: ['_unify', 'special_remark'], isShow: true, color: '#F56C6C' },
        { title: '是否有签独家', value: ['_exclusive', 'other_activity'], isShow: true, color: '#F56C6C' },
        { title: '是否可签保价1月', value: ['_support_value'], isShow: true, color: '#F56C6C' },
        { title: '历史销量', value: ['sales_volume'], isShow: true },
        { title: '备注', value: ['remark'], isShow: true }
      ],
      high_kickback: high_kickback,
      chat_quan_an: chat_quan_an,
      ingredientVisible: false
    }
  },
  methods: {
    localNextOne() {
      this.isNextOne = !this.isNextOne
      localStorage.setItem('lbNextOne', this.isNextOne)
    },
    closeEdit() {
      this.introVisible = false
    },
    editData(file, value) {
      this.introVisible = true
      this.editType = file
      this.editContent = value
    },
    async onOpen() {
      this.showIndex = this.currentIndex
      await this.getDataList()
      this.isNextOne = localStorage.getItem('lbNextOne') === 'true'
      this.fullscreen = localStorage.getItem('lbFullscreen') === 'true'
      this.fullscreen ? this.openFullscreen() : ''
    },
    onClose() {
      //记录关闭的时候 是全屏还是非全屏
      document.fullscreenElement !== null ? localStorage.setItem('lbFullscreen', 'true') : localStorage.setItem('lbFullscreen', 'false')
      this.closeFullscreen()
      this.dataList = []
      this.showIndex = 0
      this.formData = {}
      this.$emit('update:currentIndex', this.showIndex)
    },

    changeFull() {
      this.fullscreen = !this.fullscreen
      this.fullscreen ? this.openFullscreen() : this.closeFullscreen()
      localStorage.setItem('lbFullscreen', this.fullscreen)
    },
    async saveEdit() {
      if (this.editType === 'intro') {
        this.formData.intro = this.editContent || ''
        await this.editCellVal('intro', this.formData.intro)
      } else if (this.editType === 'light_spot') {
        this.formData.light_spot = this.editContent || ''
        await this.editCellVal('light_spot', this.formData.light_spot)
      } else if (this.editType === 'opt_remark') {
        this.formData.opt_remark = this.editContent || ''
        await this.editCellVal('opt_remark', this.formData.opt_remark)
      }
      this.introVisible = false
    },
    async editCellVal(field, value) {
      if (this.formData.id) {
        let id = null
        if (this.isType === 3) {
          id = await this.$api.singleSaveVideoScheduleProduct(this.formData.id, field, value)
        } else
          id = await this.$api.singleSaveLbScheduleProduct(this.formData.id, field, value)
        if (id) {
          this.formData[field] = value
          this.$set(this.dataList[this.showIndex], field, value)
          this.$message.success('保存成功！')
          setTimeout(() => {
            this.showStateImg = true
            if (this.isNextOne && field === 'state') {
              setTimeout(() => {
                !(this.showIndex === this.dataList.length - 1) ? this.nextBtn() : ''
                this.loading = false
              }, 1000)
            }
          }, 600)
          this.$forceUpdate()

        }
      } else {
        this.$message.warning('参数错误，无法提交！！！')
      }
    },
    handleTinymceInput(val) {
      this.editContent = val
    },
    onchange(value) {
      // userPermissions.indexOf("lb_kol_selection_state")>-1
      this.showStateImg = false
      this.stateChange(value)
      this.formData.state = value
      this.isNextOne && !(this.showIndex === this.dataList.length - 1) ? this.loading = true : ''

    },
    async stateChange(item) {
      if (!this.isMultiple) {
        const data = {
          ids: [this.formData.id],
          state: item
        }
            let id=null
        if (this.isType === 3) {
           id = await this.$api.updateLbVideoSelectionState(data)
        }else
         id = await this.$api.updataKolSelectionState(data)
        if (id) {
          // this.formData['state'] = value
          // this.$set(this.dataList[this.showIndex], 'state', value)
          this.$message.success('保存成功！')
          setTimeout(() => {
            this.showStateImg = true
            if (this.isNextOne) {
              setTimeout(() => {
                !(this.showIndex === this.dataList.length - 1) ? this.nextBtn() : ''
                this.loading = false
              }, 1000)
            }
          }, 600)
          this.$forceUpdate()
        }
      }

      // updataKolSelectionState
    },
    close() {
      this.$emit('update:visible', false)
    },
    nextBtn() {
      this.loadingText = '正在进入下一页...'
      this.showData = false
      this.loading = true
      // this.getData()
      setTimeout(() => {
        if (!(this.showIndex === this.dataList.length - 1)) {
          this.showIndex++
        }
        this.getData()
      }, 1000)

    },
    preBtn() {
      this.loadingText = '正在进入上一页...'
      this.showData = false
      this.loading = true
      // this.getData()
      setTimeout(() => {
        if (!(this.showIndex === 0)) {
          this.showIndex--
        }
        this.getData()
      }, 1000)
    },
    async getData() {
      this.formData = {}
      const obj = this.dataList[this.showIndex]
      this.formData = obj
      this.uploadFileList = [{ url: obj.cover_url }]
      this.loading = false
      this.showData = true
    },
    async getDataList() {
      // isPreview
      const searchCondition = { lb_id: this.lbId, ...this.searchCondition }
      if (!this.isPreview) {
        searchCondition.is_ack = 'Y'
      }
      if (Number(this.isType) !== 3) {
        const {list} = await this.$api.getLbScheduleKolSelection(searchCondition)
        if (list.length === 0) {
          this.$notify.error('暂无已确认选品,请到PPT预览')
          this.showData = false
          setTimeout(() => {
            this.close()
          }, 600)
        } else {
          this.$nextTick(() => {
            this.dataList = list
            this.getData()
          })
        }
      } else {
        const {list} = await this.$api.getVideoScheduleKolSelection(searchCondition)
        if (list.length === 0) {
          this.$notify.error('暂无已确认选品,请到PPT预览')
          this.showData = false
          setTimeout(() => {
            this.close()
          }, 600)
        } else {
          this.$nextTick(() => {
            this.dataList = list
            this.getData()
          })
        }
      }

    },
    openFullscreen() {
      if (this.fullscreen) {
        if (document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled) {
          const element = document.getElementById('my-element')
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.mozRequestFullScreen) { // Firefox
            element.mozRequestFullScreen()
          } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
            element.webkitRequestFullscreen()
          } else if (element.msRequestFullscreen) { // Internet Explorer and Edge
            element.msRequestFullscreen()
          }
        }
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen && document.fullscreenElement !== null) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { // Internet Explorer and Edge
        document.msExitFullscreen()
      }
    },
    handleFullscreenChange() {
      if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
        this.fullscreen = true
      } else {
        this.fullscreen = false
      }
      localStorage.setItem('lbFullscreen', this.fullscreen)
    },
    editImgBtn() {
      this.editImgDialog = true
    },
    async saveImg() {
      const postData = {
        id: this.formData.product_id,
        cover: this.editImg.cover,
        cover_url: this.editImg.full_path
      }
      const id = await this.$api.saveProductPart('formBase', postData)
      if (id) {
        this.$message.success('成功')
        this.formData.cover_url = this.editImg.full_path
        this.editImgDialog = false
      }
    },
    // 图片删除回调
    handleUploadRemove() {
      this.editImg = this.formData.cover_url
    },
    handleUploadSuccess(file) {
      this.editImg = {
        full_path: file.full_path,
        cover: file.id
      }
    },
    cancelBtn() {
      this.editImg = {}
      this.editImgDialog = false
    },
    async handleClose(item, value) {
      item.isShow = value
      // localStorage.setItem('lbPreviewRow', JSON.stringify(this.configData))
      const data = {
        type: 'product_slide',
        settings: JSON.stringify(this.configData)
      }
      await this.$api.saveMySetting(data)
    },
    async getPptUserSetting() {
      const data = {
        type: 'product_slide',
        user_id: this.userInfo.id
      }
      const { info } = await this.$api.getMySetting(data)
      const tableSet = info.settings ? JSON.parse(info.settings) : null
      if (tableSet) this.configData = tableSet
    },

    // 打开成分表弹框
    openIngredientDialog() {
      this.ingredientVisible = true
    },

    // 关闭成分表弹框
    closeIngredientDialog() {
      this.ingredientVisible = false
    },

    // 获取表格表头
    getTableHeaders() {
      if (this.formData.ingredient_propose_parse && this.formData.ingredient_propose_parse.table) {
        return this.formData.ingredient_propose_parse.table.th || []
      }
      return []
    },

    // 获取列宽
    getColumnWidth(header) {
      const widthMap = {
        '成分': '120',
        '作用': '200',
        '刺激性/致敏性': '150',
        '安全分': '100',
        '备注': '150'
      }
      return widthMap[header] || '120'
    }

  },
  mounted() {
    const _t = this
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange) // Firefox
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange) // Chrome, Safari and Opera
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange) // Internet Explorer and Edge
    document.onkeydown = function(event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        _t.nextBtn()
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        _t.preBtn()
      }
    }
    this.getPptUserSetting()
    // const tableSet = JSON.parse(localStorage.getItem('lbPreviewRow'))
    // if(tableSet) this.configData=tableSet
  }
}
</script>

<style lang='scss' scoped>

.preview-box {
  color: #333;
  overflow: hidden;
  font-family: "Microsoft YaHei", sans-serif;

  .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    background-color: #f8f9fa;
    padding: 10px 15px;
    margin-bottom: 15px;
    border-radius: 4px;
    color: #2c3e50;
  }

  .base-info {
    flex: 8;
    font-size: 14px;
    line-height: 1.5;

    .el-row {
      padding: 0 8px;
    }
  }

  .light-spot-title {
    font-size: 20px;
    font-weight: 700;
    padding: 10px 0;
    margin-bottom: 10px;
    color: #2c3e50;
  }

.light-spot-box {
  width: 100%;
  height: 45vh;
  min-height: 200px;
  max-height: 55vh;
  background-color: #f8f9fa;
  padding: 0 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  margin-top: 12px;

  .light-spot-content {
    margin-top: 8px;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    padding: 8px;
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.5;
    font-size: 14px;

    > ::v-deep p {
      margin: 0 !important;
    }
  }
}
}

.cover-box {
  flex: 4;
  background-color: #f8f9fa;
  margin-left: 4px;
  width: 100%;
  min-height: 320px;
  border-radius: 4px;
}

.cover-title {
  text-align: center;
  width: 100%;
  line-height: 24px;
  font-weight: 700;
  font-size: 18px;
  padding: 10px 0;
  color: #2c3e50;
}

.cover-view {
  padding: 8px 0;

  > * {
    width: 180px;
    display: block;
    margin: 0 auto;
    padding: 8px;
  }
}

.introBox {
  margin-top: 8px;
  border: 1px solid #e9ecef;
  border-radius: 4px;

  > * {
    padding: 8px
  }

  .intro {
    height: 45vh;
    min-height: 200px;
    max-height: 55vh;
    overflow-y: auto;
    overflow-x: hidden;
    cursor: pointer;
    padding: 8px;
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.5;
    font-size: 14px;
    background-color: #fff;
  }
}

.opt-box {
  width: 98%;
  position: absolute;
  bottom: 2px;
  opacity: 0.3;
}

.opt-box:hover {
  opacity: 1;
  transition-duration: 0.3s;
}

.pptTitle {
  height: 18px;
  font-size: 16px;
  font-weight: 600;
}

.stateImg {
  width: 180px;
  height: 180px;
  position: absolute;
  display: block;
  right: 10px;
  z-index: 99;
  top: 20%;
}

.image-slot {
  text-align: center;
  margin: 40% auto;
  color: #6c757d;
  font-size: 14px;
}

.cover-image {
  width: 280px;
  height: 280px;
  display: block;
  margin: 0 auto;
}

::v-deep .labelClass {
  width: 160px;
  font-size: 15px;
  color: #666;
  font-weight: 600;
}

::v-deep .contentClass {
  width: 100%;
  display: inline;

  > span {
    color: #2c3e50;
    font-size: 15px;
    font-weight: 500;
  }

  > i {
    display: inline-block;
    float: right;
    margin-right: 15px;
    line-height: 20px;
    cursor: pointer;
  }
}

::v-deep .el-descriptions-item {
  padding-bottom: 2px;
}

.alertPage {
  position: absolute;
  z-index: 99;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 500px;
  height: 100px;
  text-align: center;

  > img {
    width: 30px;
    height: 30px;
    vertical-align: middle;
    animation: change 3s;
    animation-iteration-count: infinite;
    margin-right: 10px;
  }


  --bg-size: 400%;
  --color-one: rgb(73, 47, 93);
  --color-two: #ff3176;
  font-size: clamp(1rem, 25vmin, 1rem);
  background: linear-gradient(
          90deg,
          var(--color-one),
          var(--color-two),
          var(--color-one)
  ) 0 0 / var(--bg-size) 100%;
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  animation: move-bg 8s infinite linear;

}

@media (prefers-reduced-motion: no-preference) {
  .boujee-text {
    animation: move-bg 8s linear infinite;
  }
  @keyframes move-bg {
    to {
      background-position: var(--bg-size) 0;
    }
  }
}

@keyframes change {
  0% {
    transform: rotate(45deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

.configure {
  //bottom: 10px;
  margin: 10px 0;
  //min-height: 40px;
  //border: 1px #ff3176 dotted;

  > b {
    //display: block;
    width: 80px;
    height: 120px;
    //margin-top: 10px;
    color: #8a8f97;
    font-size: 14px;
  }

  > span {
    margin-right: 10px;
  }
}

.box {
  position: relative;
}

.hightKickback {
  width: 200px;
  position: absolute;
  display: block;
  right: 90px;
  top: 10%;
  opacity: 0.8;
  //z-index: 99;
  //top: 30%;
  z-index: 0;

  > img {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .space {
    position: absolute;
    top: 26px;
    color: black;
    right: 16px;
    font-size: 20px;
    line-height: 30px;
    width: 62px;
    //font-style: italic;
  }

  .online {
    position: absolute;
    top: 72px;
    color: black;
    right: 16px;
    font-size: 20px;
    line-height: 30px;
    width: 62px;
  }
}

.chat-quan-an {
  width: 270px;
  position: absolute;
  display: block;
  right: 300px;
  top: 9.5%;
  opacity: 0.8;
  //z-index: 99;
  //top: 30%;
  z-index: 0;

  > img {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .space {
    position: absolute;
    top: 87px;
    color: black;
    right: 164px;
    font-size: 14px;
    line-height: 30px;
    width: 62px;
    text-align: center;
    //font-style: italic;
  }

  .online {
    position: absolute;
    top: 87px;
    color: black;
    right: 20px;
    font-size: 14px;
    line-height: 30px;
    width: 100px;
    text-align: center;
  }
}

.ingredient-icon {
  margin-left: 10px;
  color: #409EFF;
  cursor: pointer;
  font-size: 20px;
  transition: color 0.3s;
}

.ingredient-icon:hover {
  color: #66b1ff;
}

.ingredient-content {
  padding: 20px;
  min-height: 200px;
  line-height: 1.6;
}

.dialog-footer {
  text-align: center;
  padding: 10px 20px 20px;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 14px;
}

.ingredient-content .el-table {
  margin: 0;
}

.ingredient-content .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.ingredient-content .el-table .el-table__row:hover {
  background-color: #f5f7fa;
}

.memo-content {
  color: #909399;
  line-height: 1.6;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ai-analysis {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 4px;
  float: right;
}
</style>
<style>
.tox-tinymce-aux {
  z-index: 999999 !important;
}
</style>
